//import windData from "./windData"
import portData from "./portData"
import seaCurrentData  from "./seaCurrentData"
import seaWaveData from "./sea-wave"
import salinityData from "./salinit"
import pressureData from "./pressure"
import temperatureData from "./temperature"

export default {
  //windData: windData,
  PORT_FLAG: portData,
  seaCurrentData: seaCurrentData,
  seaWaveData: seaWaveData,
  salinityData: salinityData,
  pressureData: pressureData,
  temperatureData: temperatureData,
}
